import { ReactNode, useId } from 'react';
import { Badge } from '../Badge/Badge';
import { Text } from '../Text/Text';

export type SectionProps = {
  title: string;
  description?: string;
  severity?: 'attention';
  count?: number;
  badgeLabel?: (count: number) => string;
  children: ReactNode;
};

export const Section = ({
  title,
  description,
  severity,
  count = 0,
  badgeLabel,
  children,
}: SectionProps) => {
  const titleId = useId();

  return (
    <section aria-labelledby={titleId} className="space-y-xs">
      <div className="space-y-xxs">
        <div className="flex items-center gap-xs">
          <Text as="h2" size="labelStrong" id={titleId}>
            {title}
          </Text>
          {badgeLabel && count > 0 && (
            <>
              <span aria-hidden className="inline-flex">
                <Badge
                  intent={severity ?? 'attention'}
                  size="medium"
                  value={count}
                  pulse
                />
              </span>
              <span className="sr-only">{badgeLabel(count)}</span>
            </>
          )}
        </div>
        {description && (
          <Text as="p" size="bodyS" color="contentSubdued">
            {description}
          </Text>
        )}
      </div>
      <div className="space-y-xs">{children}</div>
    </section>
  );
};
